<template>
  <div>
     <v-card class="form">
      <div class="fullText">{{ desc }}</div>
    </v-card>
    <app-actions @nextStep="nextStep" ></app-actions>
  </div>
</template>

<script>
import Actions from './Actions'
export default {
  components:{
    appActions: Actions
  },
  props: ["desc"],
  methods:{
    nextStep() {
      this.$emit('nextStep');
    }
  }
};
</script>
<style scoped></style>
